import React, { useContext } from 'react';
import {
	Bag,
	BoxArrowUpRight,
	List,
	Person,
	Search,
	X,
} from 'react-bootstrap-icons';

import { StoreContext } from '../../../context/store';
import useSiteMetadata from '../../../hooks/use_site_metadata';
import useSticky from '../../../hooks/use_sticky';
import useTranslation from '../../../hooks/use_translation';
import logo from '../../../images/framework/logo.svg';
import BtnIcon from '../buttons/btn_icon';
import Counter from '../counter';
import Language from '../language';
import Link from '../link';
import CategoryDropdown from './category-dropdown';

const Header = () => {
	const { countItems } = useContext(StoreContext);
	const siteMetadata = useSiteMetadata();
	const { t } = useTranslation('component_header');
	const { sticky, stickyRef } = useSticky();

	return (
		<>
			<header
				className={`navbar-bg ${sticky ? 'fixed-top shadow-sm' : ''}`}
				id="header_navigation"
				ref={stickyRef}
			>
				<div className="navbar navbar-expand-lg pb-0">
					<div className="navbar-nav-first d-flex container">
						<Link className="navbar-brand me-0 d-none d-lg-block" to="/">
							<img
								alt="Testmottagningen logo"
								className="d-inline mx-auto"
								src={logo}
							/>
						</Link>
						<div className="navbar-nav-right d-none justify-content-end d-lg-flex align-items-center">
							<ul className="navbar-nav  px-0 px-lg-2 py-1 flex-row">
								<li className="nav-item d-none d-lg-block">
									<BtnIcon
										iconSize="md"
										labelBefore={t('t7')}
										labelSize="xs"
										linkType="link"
										size="sm"
										to="/sok/"
										variant="nav"
									>
										<Search />
									</BtnIcon>
								</li>

								<li className="nav-item nav-item-sign_in d-none d-lg-block">
									<BtnIcon
										iconSize="md"
										labelBefore={t('t9')}
										labelSize="xs"
										linkType="link"
										size="nav_user"
										target="_blank"
										to="https://app.zample.com/?partner=testmottagningen"
										variant="nav"
									>
										<Person />
									</BtnIcon>
								</li>
								<li className="nav-item">
									<BtnIcon
										iconSize="md"
										labelBefore={t('t8')}
										labelSize="xs"
										linkType="link"
										size="sm"
										to="/varukorg/"
										variant="nav"
									>
										<Bag />
										{countItems > 0 && (
											<Counter number={countItems} text={t('t14')} />
										)}
									</BtnIcon>
								</li>
							</ul>
							<div className=" mt-3 mt-lg-0 mb-0">
								<Language />
							</div>
						</div>
					</div>
				</div>
				<div className={`navbar navbar-expand-lg navbar-bg`}>
					<div className="container justify-content-between ">
						<Link className="navbar-brand me-0 d-block d-lg-none" to="/">
							<img
								alt="Testmottagningen logo"
								className="d-inline mx-auto"
								src={logo}
							/>
						</Link>
						<div className="navbar-nav-bottom">
							<div
								aria-labelledby="navbarOffcanvasLabel"
								className="offcanvas nav-full offcanvas-end"
								data-bs-scroll="true"
								id="navbarOffcanvas"
							>
								<div className="offcanvas-header pb-0 d-flex d-lg-none justify-content-between">
									<div className="d-flex d-lg-none justify-content-center  mt-lg-0 ">
										<Language />
									</div>
									<button
										aria-label="Close"
										className="btn-text btn d-lg-none"
										data-bs-dismiss="offcanvas"
										type="button"
									>
										<span
											className="x-small ms-1 fw-600"
											id="navbarOffcanvasLabel"
										>
											{t('t2')}
										</span>
										<X className="lead" />
									</button>
								</div>
								<div className="offcanvas-body">
									<Link
										className="small d-block me-1 d-lg-none mb-3 py-2 px-3 text-dark text-decoration-none rounded-pill bg-light"
										role="button"
										to="/sok/"
									>
										<Search />
										<span className="ms-1">{t('t3')}</span>
									</Link>
									<div className="d-lg-flex justify-content-between w-100">
										<div className="d-lg-flex">
											<ul className="navbar-nav mt-md-0">
												<li className="nav-item dropdown position-static">
													<Link
														aria-expanded="false"
														className="nav-link dropdown-toggle  ps-lg-0 me-1"
														data-bs-toggle="dropdown"
														role="button"
														to="/tester/"
													>
														{t('t4')}
													</Link>

													<CategoryDropdown />
												</li>

												<li className="nav-item">
													<Link
														className="nav-link me-1"
														to={`/halsokontroller/`}
													>
														{t('t6')}
													</Link>
												</li>

												{/* Reactivate when we have more tests */}
												{process.env.NODE_ENV == 'development' && (
													<li className="nav-item">
														<Link
															className="nav-link me-1"
															to={`/sjalvtester/`}
														>
															{t('t21')}
														</Link>
													</li>
												)}

												<li className="nav-item">
													<Link
														className="nav-link me-1"
														to={`/halsoundersokningar/`}
													>
														{t('t11')}
													</Link>
												</li>
											</ul>
											<ul className="navbar-nav">
												<li className="nav-item">
													<Link className="nav-link me-1" to={`/mottagningar/`}>
														{t('t10')}
													</Link>
												</li>

												<li className="nav-item">
													<Link className="nav-link me-1" to={`/fakta/`}>
														{t('t13')}
													</Link>
												</li>
												<li className="nav-item">
													<Link
														className="nav-link me-1"
														to={`/sa-fungerar-det/`}
													>
														{t('t12')}
													</Link>
												</li>
												{/* Reactivate when
												{siteMetadata?.config?.campaigns && (
													<li className="nav-item">
														<Link className="nav-link" to="/kampanjer/">
															{t('t5')}
														</Link>
													</li>
												)}
													*/}
											</ul>
										</div>
										<div className="d-lg-flex">
											<ul className="link-separator d-flex align-items-center text-center mt-3 mt-lg-0 px-0 justify-content-center">
												<li className="nav-item d-flex flex-row align-items-center link-separator-item pe-2">
													<Link
														aria-current="page"
														className="nav-link-sm active"
														to={`/`}
													>
														{t('t15')}
													</Link>
												</li>

												<li className="nav-item d-flex align-items-center ps-2">
													<Link
														className="nav-link-sm"
														to={`/foretagshalsovard/`}
													>
														{t('t16')}
													</Link>
												</li>
											</ul>
										</div>

										<Link
											className=" me-1 d-block d-lg-none btn btn-dark text-light py-2 mt-3"
											target="_blank"
											to="https://app.zample.com/?partner=testmottagningen"
										>
											{t('t9')}
											<BoxArrowUpRight className="ms-1" />
										</Link>
									</div>
								</div>
							</div>
						</div>

						<div className="navbar-nav-right d-flex justify-content-end d-lg-none">
							<ul className="navbar-nav align-items-center px-0 px-lg-2 py-0 flex-row">
								<li className="nav-item d-lg-block">
									<BtnIcon
										aria-label={t('t7')}
										iconSize="md"
										linkType="link"
										size="sm"
										to="/sok/"
										variant="nav"
									>
										<Search />
									</BtnIcon>
								</li>

								<li className="nav-item">
									<BtnIcon
										aria-label={t('t8')}
										iconSize="md"
										linkType="link"
										size="sm"
										to="/varukorg/"
										variant="nav"
									>
										<Bag />
										{countItems !== 0 && (
											<Counter number={countItems} text={t('t14')} />
										)}
									</BtnIcon>
								</li>
								<li className="nav-item">
									<BtnIcon
										aria-controls="navbarOffcanvas"
										aria-label="Menu"
										data-bs-target="#navbarOffcanvas"
										data-bs-toggle="offcanvas"
										iconSize="md"
										linkType="button"
										size="nav"
										variant="nav"
									>
										<List />
									</BtnIcon>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</header>
			<div
				style={{
					height: sticky ? `${stickyRef.current?.clientHeight}px` : '0px',
				}}
			/>
		</>
	);
};

export default Header;
